import React from 'react';
import { emphasize, withStyles } from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Chip from '@material-ui/core/Chip';
import HomeIcon from '@material-ui/icons/Home';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import { useHistory } from "react-router-dom";
//import { Redirect } from "react-router-dom";

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },
}))(Chip); // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

// function handleClick(event,url) {
//   event.preventDefault();
//   console.info(url);
//   return <Redirect to={url} />
// }

export default function CustomizedBreadcrumbs(props) {
  //let history = useHistory();
  return (
    <Breadcrumbs aria-label="breadcrumb" style={{marginBottom:'5px'}}>
      {props.data.map((item,i)=>{
        return  <StyledBreadcrumb
        component="a"
        href={item.url}
        label={item.title}
        icon={<HomeIcon fontSize="small" />}
        // onClick={(e)=>{handleClick(e,'/dashboard')}}
      />
      })}
      
      {/* <StyledBreadcrumb component="a" href="#" label="Catalog" onClick={handleClick} />
      <StyledBreadcrumb
        label="Accessories"
        deleteIcon={<ExpandMoreIcon />}
        onClick={handleClick}
        onDelete={handleClick}
      /> */}
    </Breadcrumbs>
  );
}


// WEBPACK FOOTER //
// ./src/component/Breadcrumbs.js